import React from 'react';
import { Play, Square } from 'lucide-react';
import { cn } from '../lib/utils';
import { Button } from './ui/button';

interface ClockButtonProps {
  isClockedIn: boolean;
  onClick: () => void;
  disabled?: boolean;
}

export const ClockButton: React.FC<ClockButtonProps> = ({ isClockedIn, onClick, disabled }) => (
  <Button
    variant={isClockedIn ? 'secondary' : 'success'}
    onClick={onClick}
    disabled={disabled}
    className={cn(isClockedIn && 'border-success/30 pl-3')}
    aria-label={isClockedIn ? 'Clock out' : 'Clock in'}
  >
    {isClockedIn ? (
      <>
        <span className="size-2 animate-pulse-dot rounded-full bg-success" aria-hidden />
        <span className="hidden sm:inline">On the clock</span>
        <span className="hidden h-4 w-px bg-line-strong sm:block" aria-hidden />
        <Square className="size-3.5 fill-current text-danger" />
        <span>Clock out</span>
      </>
    ) : (
      <>
        <Play className="size-3.5 fill-current" />
        <span>Clock in</span>
      </>
    )}
  </Button>
);
